import React, { useCallback, useState } from "react";
import { Banner } from "@bookingcom/bui-react";
import { getCampaignBannerAsset } from "../../../utils/flightCampaignConfig.js";
import { FlightCampaignTCBannerModal } from "./FlightCampaignTCBannerModal.js";
import { getImageAssetUrl } from "@bookingcom/bui-assets-react";
export const FlightCampaignTCBanner = ({ campaignBanner, onCtaClick }) => {
    const [showModal, setShowModal] = useState(false);
    const onCloseModal = () => {
        setShowModal(false);
    };
    const onShowModal = useCallback(() => {
        setShowModal(true);
        typeof onCtaClick === "function" && onCtaClick();
    }, [onCtaClick]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Banner, { title: campaignBanner.title, text: campaignBanner.text, startImage: {
                src: getImageAssetUrl(getCampaignBannerAsset(campaignBanner.style)),
                alt: ""
            }, dismissible: false, bleed: false, actions: [
                {
                    text: campaignBanner.action.ctaText,
                    variant: "tertiary",
                    onClick: onShowModal
                }
            ] }),
        React.createElement(FlightCampaignTCBannerModal, { isActive: showModal, onModalClose: onCloseModal, campaignBanner: campaignBanner })));
};
